import { BergMarquee } from "@berg-regions/berg-components";
import { useAnnouncements } from "../../lib/hook/useAnnouncements";
import "./AlertsBar.scss";

const AlertsBar = () => {
  const { announcements } = useAnnouncements();

  if (!announcements || announcements.length === 0) {
    return null;
  }

  return (
    <div className="absolute bottom-0 w-full berg-led">
      <BergMarquee
        announcements={announcements}
        timeInterval={20}
        initialAnimationDuration={20}
        pauseOnHover={true}
      />
    </div>
  );
};

export default AlertsBar;
